/**
 * ToolbarContext Stub
 *
 * Provides toolbar customization capability for dashboard views.
 * This is a stub that will be replaced with proper Shell integration.
 */
import { createContext, useContext, useState, type ReactNode } from 'react';

interface ToolbarContextType {
  customComponent: ReactNode | null;
  setCustomComponent: (component: ReactNode | null) => void;
}

const ToolbarContext = createContext<ToolbarContextType | undefined>(undefined);

export const useToolbar = (): ToolbarContextType => {
  const context = useContext(ToolbarContext);
  if (!context) {
    // Return a no-op version when not inside provider
    return {
      customComponent: null,
      setCustomComponent: () => {},
    };
  }
  return context;
};

interface ToolbarProviderProps {
  children: ReactNode;
}

export const ToolbarProvider = ({ children }: ToolbarProviderProps) => {
  const [customComponent, setCustomComponent] = useState<ReactNode | null>(null);

  return (
    <ToolbarContext.Provider value={{ customComponent, setCustomComponent }}>
      {children}
    </ToolbarContext.Provider>
  );
};
